import React from "react";
import { Award, Leaf, HandCoins, Clock, Users, Truck } from "lucide-react";

const items = [
  { icon: Award, title: "Veteran-owned", body: "Service, integrity and pride in every garment." },
  { icon: Users, title: "Trusted since 1993", body: "Same Chandler location for over 30 years — now under proud new ownership." },
  { icon: Truck, title: "Free pickup & delivery", body: "Door-to-door, no minimums, on your schedule." },
  { icon: Leaf, title: "Eco-friendly process", body: "Modern, gentle solvents that protect your fabrics." },
  { icon: HandCoins, title: "Honest pricing", body: "No surprise fees. See pricing before we pick up." },
  { icon: Clock, title: "48-hour turnaround", body: "Most orders cleaned and returned within two days." },
];

export default function WhyUs() {
  return (
    <section
      data-testid="why-us-section"
      className="py-20 lg:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-brand-blue">
            Why Oxford
          </p>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-brand-navy">
            Local roots.
            <span className="block text-brand-blue">Better results.</span>
          </h2>
          <p className="mt-5 text-slate-600 leading-relaxed">
            We're your neighbors at Ray Rd & 56th St — and we treat your
            clothes like they're our own. Here's what makes us different.
          </p>

          <div className="mt-8 rounded-2xl border border-slate-200 bg-slate-50 p-6">
            <div className="us-stripe h-1 rounded-full mb-4" />
            <p className="font-display text-lg font-semibold text-brand-navy">
              Proudly serving veterans & first responders
            </p>
            <p className="mt-2 text-sm text-slate-600">
              Ask about our 10% appreciation discount — every visit.
            </p>
          </div>
        </div>

        <div className="lg:col-span-8 grid sm:grid-cols-2 gap-4">
          {items.map((it) => (
            <div
              key={it.title}
              data-testid={`why-item-${it.title.toLowerCase().replace(/\s|&/g, "-").replace(/--/g, "-")}`}
              className="lift rounded-2xl border border-slate-200 bg-white p-6 flex gap-4"
            >
              <div className="h-11 w-11 shrink-0 rounded-xl bg-brand-lightblue grid place-items-center text-brand-blue">
                <it.icon className="h-5 w-5" />
              </div>
              <div>
                <h3 className="font-display text-lg font-semibold text-brand-navy">
                  {it.title}
                </h3>
                <p className="mt-1 text-sm text-slate-600 leading-relaxed">
                  {it.body}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
